import * as React from 'react';

import { Context } from './context';
import { INITIAL_REDUCER_STATE, reducer } from './reducer';

export default function PagePrefCardActionContext({ children }: { children: React.ReactNode }) {
  return <Context.Provider value={React.useReducer(reducer, INITIAL_REDUCER_STATE)}>{children}</Context.Provider>;
}
